import { createSwiper, withResize } from '../../components/swiper-init.js';

// ─── Mission Description Scroll ───────────────────────────────────────────────
// Stops the wheel-event from bubbling so scrolling inside the description
// doesn't move the page. Adds an `is-end` class once scrolled to the bottom.
function initMissionScroll() {
  document.querySelectorAll('.mission-slider_description').forEach((el) => {
    el.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });

    el.addEventListener('scroll', () => {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 4;
      el.classList.toggle('is-end', atBottom);
    });
  });
}

export function initSwiperAboutWithResize() {
  // Scroll behavior runs once — listeners persist across resizes.
  initMissionScroll();

  withResize(() => {
    createSwiper('principles');
    createSwiper('mission', {
      loop: true,
      slideToClickedSlide: true,
      breakpoints: { 992: { slidesPerView: 'auto' } },
    });
  });
}
